import DashboardWithOpenSideNav from "components/Layout/DashboardWithOpenSideNav/DashboardWithOpenSideNav";
import { shippingPartnerDrawerElements } from "components/ShippingPartnerReco/data";
import ShippingPartnerRecoDashboard from "components/ShippingPartnerReco/ShippingPartnerDashboard";
import { Route } from "react-router-dom";

export const generateShippingPartnerRecoRoutesFromServiceTree = (service, rootPath) => {
	if (service?.types) {
		const defaultRoute = Object.values(service.types)[0];
		return (
			<Route key={service.key} path={service.key}>
				<Route
					index
					element={
						<DashboardWithOpenSideNav
							drawerList={shippingPartnerDrawerElements}
							navSpace={1}
							service={defaultRoute}
							pathName={defaultRoute.key}
							rootPath={rootPath}
						/>
					}
				/>
				{service.types &&
					Object.keys(service.types).map((childKey) =>
						generateShippingPartnerRecoRoutesFromServiceTree(service.types[childKey], rootPath)
					)}
			</Route>
		);
	} else
		return (
			<Route
				key={service.key}
				path={service.key}
				element={
					<DashboardWithOpenSideNav
						drawerList={shippingPartnerDrawerElements}
						navSpace={1}
						service={service}
						pathName={service.key}
						rootPath={rootPath}
					/>
				}>
				<Route index element={<ShippingPartnerRecoDashboard />} />
			</Route>
		);
};
